import styles from './Page.module.scss';

function Page({ title, extra, className, children }) {
    const rootClass = [styles.page, className].filter(Boolean).join(' ');

    return (
        <section className={rootClass}>
            {(title || extra) && (
                <header className={styles.header}>
                    {title ? <h1 className={styles.title}>{title}</h1> : <span />}
                    {extra ? <div className={styles.extra}>{extra}</div> : null}
                </header>
            )}
            <div className={styles.body}>{children}</div>
        </section>
    );
}

export default Page;
